import React, { memo } from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints() {
  const dataPoints = useSelector((state) => state.utilization.graphData.utilization_by_category);
  if (!dataPoints.length) return null;

  const symbol = useSelector((state) => state.utilization.chartCurrencySymbol);

  //total data point
  const { label, value, url, subProps } = dataPoints[0];

  let restDataPoints = dataPoints.slice(1);

  const style = {
    flexBasis: restDataPoints.length <= 5 ? "0" : restDataPoints.length % 2 === 0 ? "32%" : "24%",
    flexGrow: restDataPoints.length <= 5 ? "1" : 0
  };

  return (
    <div className="data-points">
      <div className="data-point">
        <DataDisplay
          key={label}
          label={label}
          value={value}
          currency={symbol}
          url={url}
          type="money"
          {...subProps}
        />
      </div>
      {restDataPoints.length ? (
        <div className="with-border">
          {restDataPoints.map(({ label, value, url, subProps }) => {
            return (
              <div key={label} className="data-point" style={style}>
                <DataDisplay
                  size={36}
                  label={label}
                  value={value}
                  currency={symbol}
                  url={url}
                  type="money"
                  {...subProps}
                />
              </div>
            );
          })}
        </div>
      ) : (
        ""
      )}
    </div>
  );
});
